import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiModule } from '@monorepo/ui';
import { IonicModule } from '@ionic/angular';
import { UploadModalComponent } from './upload-modal/upload-modal.component';
import { UploadSummaryModalComponent } from './upload-summary-modal/upload-summary-modal.component';
import { AutoPlanOrderModalComponent } from './auto-plan-order-modal/auto-plan-order-modal.component';
import { ProcessFactoryAssignModalComponent } from './process-factory-assign-modal/process-factory-assign-modal.component';
import { BoardViewPopoverComponent } from './board-view-popover/board-view-popover.component';

@NgModule({
  declarations: [
    UploadModalComponent,
    UploadSummaryModalComponent,
    AutoPlanOrderModalComponent,
    ProcessFactoryAssignModalComponent,
    BoardViewPopoverComponent,
  ],
  imports: [CommonModule, IonicModule, UiModule],
})
export class Plani8CommonModule {}
